import { render, staticRenderFns } from "./AirLine.vue?vue&type=template&id=385fbe46&"
import script from "./AirLine.vue?vue&type=script&lang=ts&"
export * from "./AirLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports